@if (guidance.text.length > 0) {
<ion-item lines="none">
  <ion-label class="ion-text-wrap guidance-text" [innerHTML]="guidance.text"
    style="-webkit-user-select: text; -moz-user-select: text; -ms-user-select: text; user-select: text;">
  </ion-label>
</ion-item>
}

@if (learnMore.text.length > 0) {
<ion-accordion-group>
  <ion-accordion value="first" toggleIcon="caret-down-circle" toggleIconSlot="start">
    <ion-item slot="header">
      <ion-label>Learn More</ion-label>
    </ion-item>
    <!-- <div class="ion-padding" slot="content">{{learnMore.text}}</div> -->
    <div class="ion-padding" slot="content" [innerHTML]="learnMore.text"></div>
  </ion-accordion>
</ion-accordion-group>

<!-- <ion-item lines="none">
  <ion-label class="ion-text-wrap ion-font-sm" color="medium"
    style="-webkit-user-select: text; -moz-user-select: text; -ms-user-select: text; user-select: text;">
    <span class="ion-font-weight-medium">Learn More:</span> {{learnMore.text}}
  </ion-label>
</ion-item> -->
}